<button mat-flat-button class="ccorbit fw-semibold" (click)="openCreateVideoDialog('300ms', '100ms')">
    Open Video
</button>